import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IMultiYearAvailableLanguage } from '@modeso/types__aumico-lib-annualreport-be';
import { DeltaMode, ReportScope } from '../models/controls.model';

@Component({
    selector: 'comparison-controls-bar',
    templateUrl: './comparison-controls-bar.component.html',
    styleUrls: ['./comparison-controls-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparisonControlsBarComponent {
    @Input() public yearLabels: string[] = [];
    @Input() public selectedYears: string[] = [];
    @Input() public deltaMode: DeltaMode = 'pct';
    @Input() public reportScope: ReportScope = 'bilanz';
    @Input() public structMode = false;
    @Input() public hasReferenceValue = true;
    @Input() public isAllExpanded = false;
    /** True while the multi-year PDF export is being generated (POST → WebSocket roundtrip). */
    @Input() public exportInFlight = false;
    /**
     * Every locale present across the company's eligible ARs. Empty / 1-entry
     * lists hide the dropdown — only worth showing when there's a choice.
     */
    @Input() public availableLanguages: IMultiYearAvailableLanguage[] = [];
    /** Locale the response is currently filtered to. Drives the dropdown's selected state. */
    @Input() public activeLanguage: string | null = null;

    @Output() public yearToggled = new EventEmitter<string>();
    @Output() public deltaModeChanged = new EventEmitter<DeltaMode>();
    @Output() public reportScopeChanged = new EventEmitter<ReportScope>();
    @Output() public structModeToggled = new EventEmitter<void>();
    @Output() public showAllDetails = new EventEmitter<void>();
    @Output() public hideAllDetails = new EventEmitter<void>();
    @Output() public exportPdf = new EventEmitter<void>();
    @Output() public languageChanged = new EventEmitter<string>();

    public get hasMultipleLanguages(): boolean {
        return this.availableLanguages.length > 1;
    }
}
